<div class="auth-container">
  <mat-card class="auth-card">
    <mat-card-header>
      <mat-card-title>Email verification</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div style="padding:24px 8px; text-align:center;">
        <ng-container *ngIf="status === 'verifying'">
          <mat-spinner diameter="44" style="margin:0 auto 16px;"></mat-spinner>
          <h2>Confirming your email…</h2>
          <p>One moment while we activate your account.</p>
        </ng-container>

        <ng-container *ngIf="status === 'success'">
          <mat-icon color="primary" style="font-size:56px;width:56px;height:56px;">check_circle</mat-icon>
          <h2>Your email is verified</h2>
          <ng-container *ngIf="isBarOwner; else customerReady">
            <p>Thank you. Your email address is confirmed.</p>
            <p>We are now reviewing your bar's documents. You will receive an
              email as soon as your bar is approved, and you can then sign in
              to set up your drinks, staff and table QR codes.</p>
            <button mat-stroked-button routerLink="/">Back to home</button>
          </ng-container>
          <ng-template #customerReady>
            <p>Your account is active. You can sign in now.</p>
            <button mat-raised-button color="primary" routerLink="/login">Sign in</button>
          </ng-template>
        </ng-container>

        <ng-container *ngIf="status === 'error'">
          <mat-icon color="warn" style="font-size:56px;width:56px;height:56px;">error_outline</mat-icon>
          <h2>We could not verify this link</h2>
          <p>It may have expired (links are valid for 24 hours).</p>
          <p *ngIf="resent">We have sent a new link. Check your inbox.</p>
          <button *ngIf="!resent" mat-stroked-button (click)="resend()" [disabled]="resending">
            {{ resending ? 'Sending…' : 'Send me a new link' }}
          </button>
        </ng-container>

        <ng-container *ngIf="status === 'missing'">
          <mat-icon style="font-size:56px;width:56px;height:56px;">link_off</mat-icon>
          <h2>This link is incomplete</h2>
          <p>Open the link from your verification email exactly as it was sent.</p>
        </ng-container>
      </div>
    </mat-card-content>
  </mat-card>
</div>
